<template>

    <v-card>
      <v-card-title>
        <span class="headline">{{ $t('footer[0].politica')}}</span>
      </v-card-title>
      <v-card-text class="text-modal">
        <div v-html="$t('footer[1].politicaPrivacitat')"></div>
<!--  

<h3>
  Informació general de la seu electrònica o lloc web packetgrup.com i dels seus continguts </h3>
<p>
En compliment de la Llei 34/2002, d'11 de juliol, de serveis de la societat de la informació i de comerç electrònic (LSSI-CE), Packet Grup S.L., d'ara en endavant "Packet Grup" informa que és titular del lloc web www.packetgrup.com. D'acord amb l'exigència de l'article 10 de la llei esmentada, "Packet Grup" informa de les dades següents:
</p>
<p></p>
<h3>
  Usuaris
</h3>
<p>
L’accés i/o ús dels portals de "Packet Grup" atribueix la condició d’usuari que accepta des de l’inici de l’accés i/o ús l’avís legal i la política de privadesa que aquí es reflecteix. Les citades condicions seran d’aplicació independentment de les Condicions Generals de Contractació que en el seu cas resultin d’obligat compliment.
</p>
<p></p>
    <h3>
Protecció dels drets de propietat intel·lectual 
</h3>
<p>
Els continguts i elements gràfics que formen part del lloc web Packetgrup.com són de titularitat exclusiva de "Packet Grup" o de terceres persones físiques o jurídiques que n’han autoritzat l’ús a Packetgrup.com. Els continguts del lloc web són objecte de propietat intel·lectual, amb les excepcions previstes en l’article 13 del Reial decret legislatiu 1/1996, de 12 d’abril, pel qual s’aprova el text refós de la Llei de propietat intel·lectual. Per tant, qualsevol ús o reproducció que les persones usuàries facin d’aquests continguts o d’altres que es puguin incloure en el futur, s’ha de fer seguint les previsions i respectant les limitacions de la normativa esmentada.
</p>
<p>
Packetgrup.com explicita una reserva de drets amb caràcter general respecte del conjunt dels continguts difosos en el lloc web que són objecte de propietat intel·lectual i industrial.
</p>
<p>
No s’autoritza en cap cas:</p>
<ul> 
  <li>
    La presentació d’una pàgina del lloc web en una finestra que no pertany a Packetgrup.com per mitjà de ‘framing’. 
  </li>
  <li>
    La inserció d’una imatge difosa al lloc web en una pàgina que no és de Packetgrup.com  mitjançant ‘in line linking’. 
  </li>
  <li>
    L’extracció d’elements del lloc web que causi perjudici a Packetgrup.com conforme a les disposicions vigents.</li>
  <li>
    Utilitzar el web per promocionar lliurement activitats comercials.</li>
  <li>
    L’ús comercial dels continguts del lloc web Packetgrup.com.
  </li>
  <li>
    L’ús de marques o signes distintius, logotips, combinacions de colors, estructura, disseny i, en general, símbols distintius de qualsevol naturalesa propietat de "Packet Grup" sense el coneixement i l’autorització corresponent de l’empresa.
</li>
<li>
  L’ús de continguts en activitats il·lícites, il·legals o contràries a la bona fe i l’ordre públic. 
Difondre continguts o propaganda de caràcter racista o xenòfob, pornogràfic, il·legal o que atempti contra els drets humans. </li>
<li>
Provocar danys en els sistemes físics i lògics de "Packet Grup", dels seus proveïdors o de terceres persones; introduir o difondre a la xarxa virus informàtics o altres sistemes físics o lògics que siguin susceptibles de provocar danys anteriorment esmentats. </li>
<li>
Intentar accedir i, si s’escau, utilitzar els comptes de correu electrònic d’altres usuaris i modificar o manipular els seus missatges. </li>
</ul>

<p>
"Packet Grup" es reserva el dret d’instar les accions, els procediments i les mesures cautelars procedents previstos en la legislació de propietat intel·lectual, amb relació a la comissió d’infraccions de la normativa sobre propietat intel·lectual per part dels usuaris. Les infraccions que es cometin amb motiu de la utilització fraudulenta de la informació i dels continguts del lloc web Packetgrup.com poden comportar les sancions legalment previstes, en especial, en el codi penal (articles 270 i següents).</p>
<p>
</p>
    <h3>
Protecció de dades de caràcter personal <br>
</h3>
<p>
De conformitat amb el que s'estableix en la normativa vigent en protecció de dades de caràcter personal, l'informem que les seves dades seran incorporades al sistema de tractament titularitat de "Packet Grup" amb la finalitat de poder facilitar, agilitar i complir els compromisos establerts entre totes dues parts. En compliment amb la normativa vigent, "Packet Grup" informa que les dades seran conservades durant el termini estrictament necessari per complir amb els preceptes esmentats amb anterioritat.
</p>
<p>
Mentre no ens comuniqui el contrari, entendrem que les seves dades no han estat modificades, que vostè es compromet a notificar-nos qualsevol variació i que tenim el seu consentiment per utilitzar-les per a les finalitats esmentades.
</p>
<p>
"Packet Grup" informa que procedirà a tractar les dades de manera lícita, lleial, transparent, adequada, pertinent, limitada, exacta i actualitzada. És per això que "Packet Grup" es compromet a adoptar totes les mesures raonables perquè se suprimeixin o rectifiquin sense dilació quan siguin inexactes.
</p>
<p>
D'acord amb els drets que li confereix la normativa vigent en protecció de dades, podrà exercir els drets d'accés, rectificació, limitació de tractament, supressió, portabilitat i oposició al tractament de les seves dades de caràcter personal així com del consentiment prestat per al seu tractament, dirigint la seva petició a l'adreça postal indicada més amunt o al correu electrònic info@packetgrup.com.
</p>
<p>
Podrà dirigir-se a l'autoritat de control competent per presentar la reclamació que consideri oportuna.
</p>
<p>
  </p>
    <h3>
Dades de navegació <br>
</h3>
<p>
El sistema de navegació i el programari necessaris per al funcionament d’aquest lloc web recullen, de manera estàndard, algunes dades la transmissió de les quals és implícita en l’ús dels protocols de comunicació d’Internet. En aquesta categoria de dades hi ha l’adreça IP o nom de domini de l’ordinador utilitzat per la persona usuària per connectar-se al lloc web, l’adreça URL del recurs demanat, l’hora, el mètode utilitzat per a la consulta al servidor, la mida de l’arxiu obtingut en la resposta, el codi numèric que indica l’estat de la resposta al servidor, i altres paràmetres relatius al sistema operatiu de l’entorn informàtic de la persona usuària.
</p>
<p>
Aquesta informació no s’associa a persones usuàries concretes i s’utilitza amb la finalitat exclusiva d’obtenir informació estadística sobre l’ús del lloc web Packetgrup.com.
</p>
<p>
En la seva seu electrònica, Packetgrup.com no utilitza galetes (cookies) o altres mitjans de naturalesa anàloga per al tractament de dades personals que permetin la identificació de persones físiques concretes, usuàries de la seu electrònica. L’ús d’aquests mitjans es reserva exclusivament per recollir informació tècnica per facilitar a les persones usuàries l’accessibilitat i l’exploració segura i eficient de la seu electrònica de Packetgrup.com
</p>
<p>
Aquest lloc web fa servir les eines de mesurament d’audiència de Google Analytics, que permeten analitzar el comportament i el perfil dels visitants anònims amb l’objectiu de millorar el funcionament del web. Aquest mesurament utilitza galetes (cookies) de terceres parts.
</p>
<p> </p>
    <h3>
Responsabilitat amb relació als continguts
</h3>
<p>
"Packet Grup" es reserva el dret de modificar els continguts del web i d’eliminar-los, així com també de limitar o impedir-ne l’accés ja sigui temporalment o definitiva, sense notificació prèvia.
</p>
<p>
"Packet Grup" no es fa responsable de la informació o dels continguts d’altres pàgines web a les quals remet o amb les quals enllaça el portal Packetgrup.com.
</p>
<p>
"Packet Grup" no s’identifica necessàriament amb les opinions expressades pels seus col·laboradors i autors dels blogs.
</p>
<p> </p>
    <h3>
Dret d’exclusió
</h3>
<p>
"Packet Grup" es reserva el dret de denegar o retirar l’accés als seus llocs web i/o els serveis oferts sense necessitat d’avís previ, a instància pròpia o d’un tercer, a aquells usuaris que incompleixin les presents condicions generals o les normes d’ús.
</p>
<p> </p>
    <h3>
Contractació
</h3>
<p>
L’enviament de qualsevol dels formularis de comanda suposa una via de contractació electrònica en els termes que reconeix la Llei 34/2002, de serveis de la societat de la informació. Sobre la base d’aquesta llei, "Packet Grup" us informa que el correcte enviament de les dades veraces i necessàries, i la posterior efectivitat en el pagament, seran els únics tràmits a complir per a tal contractació. El document en què aquesta es formalitzi serà emmagatzemat en les nostres oficines durant el temps legalment obligatori, on es mantindrà accessible per al seu accés, rectificació o cancel·lació.
</p>
<p> </p>
    <h3>
Generalitats
</h3>
<p>
"Packet Grup" perseguirà l’incompliment de les presents condicions, així com qualsevol utilització indeguda dels seus llocs web, exercint totes les accions civils i penals que li puguin correspondre per dret.
</p>
<p> </p>
    <h3>
Modificació de les presents condicions i durada
</h3>
<p>
"Packet Grup" podrà modificar en qualsevol moment les condicions aquí determinades, essent degudament publicades com aquí apareixen. La vigència de les citades condicions anirà en funció de la seva exposició i seran vigents fins que siguin modificades per altres condicions degudament publicades.
</p>
<p> </p>
    <h3>
Legislació aplicable i jurisdicció
</h3>
<p>
La relació entre "Packet Grup" i els usuaris es regirà per la normativa espanyola vigent i qualsevol controvèrsia se sotmetrà als jutjats i als tribunals de la ciutat de Barcelona.
</p>
 -->
  </v-card-text>
        <!--
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">No estoy deacurd</v-btn>
          <v-btn color="green darken-1" text @click="dialog = false">Estoy de acuerdo</v-btn>
        </v-card-actions>
        -->
    </v-card>
</template>

<script>
// import Canvas from './Canvas.vue'

export default {
  name: 'politicaPrivacidad',
  props: {
    msg: String
  },
  components: {
  /*   Canvas */
  },
  data () {
    return {
      show: true
    }
  }
}
</script>

<style scoped lang="scss">
  h3 {
    font-weight: 500;
    font-size: 1.32em;
    margin: 25px 0 5px;
  }
.text-modal {
  margin-top: 20px;
  font-size: 0.74em;
  color: rgb(39, 39, 39) !important;
  ul { 
    margin-bottom: 20px;
  }
  li {
    font-size: 14px;
    margin:5px 0;
    display: block;
    color: rgb(39, 39, 39) !important;
  }
    li::before {
      content:"· ";
      font-size: 18px;
      font-weight: bold;
  }
}
.floating {
  position: absolute;
  left: 50%;
  font-weight: bold;
  font-size: 1em;
  bottom: 0;
}

.widget-content {
  padding:5%;
  padding-bottom: 0;
}

.Intro {
  z-index: 5;
  position: absolute;
  width: 100%;
  padding: 10%;
  left:0;
  bottom: 0;
  padding-bottom: 50px;
}

.v-btn {
  font-family: 'Laro', 'sans serif';
}

.corner-right {
  position: absolute;
  clip-path: circle(400px at 95% -180px);
  padding: 20px;
  height: 50%;
  width: 100%;
  z-index: 1;
  right: 0;
  bottom: 0;
}

.text-corner {
  margin-right: 55px;
  text-align: left;
  float: right;
  line-height: 2;
  right:-300px;
  padding-top: 40px;
  padding-bottom: 0;
  animation: Text 1s ease-in;
}

.linebase {
  background: purple;
  animation-delay: 1s;
  height: 100px;
  width:1px;
  position: absolute;
  left: 40%;
  top: 50%;
  animation: lines 4s alternate infinite;
  animation-delay: 3s;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.fadeOne-enter-active, .fadeOne-leave-active {
  transition: all .5s ease-out;
}

.fadeOne-enter, .fadeOne-leave-to {
  clip-path: polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%);
  transform: translate(0%, 100%);
}

.fadeTwo-enter-active, .fadeTwo-leave-active {
  transition: all .5s ease-out;
}
.fadeTwo-enter, .fadeTwo-leave-to {
  clip-path: polygon(0% 100%, 100% 100%, 0% 100%, 0% 100%);
  transform: translate(0%, -100%);
}

.fadethree-enter-active, .fadethree-leave-active {
  transition: all .6s ease-in-out;
}
.fadethree-enter, .fadethree-leave-to {
  transform: translate(100%, 0%);
  opacity: 10%;
  transition: all .6s ease-in-out;
}

.fadefour-enter-active, .fadefour-leave-active {
  transition: all .9s ease-in-out;
}
.fadefour-enter, .fadefour-leave-to {
  clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
  transform: translate(-50%, -100%);
  transform: rotateX(45);
}

.line1, .line2, .line3, .line4 {
	stroke-dasharray:2300;
	stroke-dashoffset:2300;
	animation: dash 5s linear forwards;
}


#spinner {
  -webkit-animation-name: spincube;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-duration: 12s;
  -webkit-transform-style: preserve-3d;
  -webkit-transform-origin: 60px 60px 0;
}

@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}
</style>
